<template>
  <anchor-modal
    v-model="display"
    width="430px"
    title="Manage Signature"
    light
    header-color="white"
    :header-split="true"
  >
    <signature-form
      v-if="user"
      :user="user"
      @cancel="() => display = false"
      @deleteSignature="deleteSignature"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import SignatureForm from './SignatureForm';


export default {
  name: 'ManageSignatureModal',
  components: {
    SignatureForm,
  },
  data() {
    return {
      display: false,
      user: null,
    };
  },
  methods: {
    open(user) {
      this.user = user;
      this.display = true;
    },
    deleteSignature() {
      this.$delete(this.user, 'signature');
      this.$emit('success');
      this.display = true;
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
  watch: {
    display(value) {
      if (!value) {
        this.user = null;
      }
    },
  },
};
</script>
